import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface HomepageSection {
  id: string;
  section_key: string;
  label: string;
  sort_order: number;
  is_visible: boolean;
  config: Record<string, unknown>;
  updated_at: string;
  starts_at: string | null;
  ends_at: string | null;
}

export function useHomepageOrder() {
  return useQuery({
    queryKey: ["homepage-order"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("homepage_content_order")
        .select("*")
        .order("sort_order");
      if (error) throw error;
      return data as HomepageSection[];
    },
    staleTime: 30_000,
  });
}

export function useUpdateHomepageOrder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (sections: { id: string; sort_order: number; is_visible: boolean }[]) => {
      for (const s of sections) {
        const { error } = await supabase
          .from("homepage_content_order")
          .update({ sort_order: s.sort_order, is_visible: s.is_visible, updated_at: new Date().toISOString() })
          .eq("id", s.id);
        if (error) throw error;
      }
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["homepage-order"] }),
  });
}
